import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import fr from "./fr";
import en from "./en";

const STORAGE_KEY = "hinvoice_lang";

const savedLang = localStorage.getItem(STORAGE_KEY) ?? "fr";

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
  },
  lng: savedLang,
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

// Persist language changes
i18n.on("languageChanged", (lng) => {
  localStorage.setItem(STORAGE_KEY, lng);
});

export default i18n;
